import React, { useContext, useMemo } from 'react'
import { ProgressBar } from 'react-bootstrap'
import HeadTitle from '../layout/HeadTitle'
import { OrdersContext, UserContext } from '../layout/Root'

export default function MyOrders() {
   const [orders] = useContext(OrdersContext)
   const [user] = useContext(UserContext)

   const myOrdersList = useMemo(() => orders.find(o => o.user._id === user._id)?.orders || [], [user._id])

   const ProgressOrder = ({ o }) => {
      const variant = o.status === 'In Progress' ? 'danger' : o.status === 'In Preparation' ? 'info' : 'success'
      const now = o.status === 'In Progress' ? 33 : o.status === 'In Preparation' ? 66 : 100
      return <ProgressBar striped animated variant={variant} label={o.status} now={now} />
   }

   return (<>
      <HeadTitle title='My Orders' />
      <div className='container-fluid'>
         <div className="container">
            <div className="row">

               {myOrdersList.length ?
                  myOrdersList.map((o, index) =>
                     <div key={o._id} className="col-lg-3 col-md-4 col-12 p-2">
                        <div className="card px-3 py-2 slide-in-left" style={{ animationDelay: `${index * 2}00ms` }}>
                           <img style={{ objectFit: 'cover' }} src={o.img} width={120} height={120} alt={o.title} className='rounded-circle mx-auto' />
                           <h3 className='fs-5 my-3'>{o.title}</h3>
                           <p>Amount: {o.amount}</p>
                           {o.notes && <p>Notes: {o.notes} </p>}
                           <p>Price: ${o.price} per dish</p>
                           <p>Status: {o.status}</p>
                           <ProgressOrder o={o} />
                        </div>
                     </div>
                  ) : <p className='mt-5'>nothing here yet...</p>}

               <div className="col-12 py-4 shadow-lg mt-4 rounded">
                  <h2>total price:  ${myOrdersList.reduce((p, c) => (c.amount * c.price) + p, 0)}</h2>
                  <h4>total calories: {myOrdersList.reduce((p, c) => (c.amount * c.calories) + p, 0)} </h4>
               </div>
            </div>
         </div>
      </div>
   </>
   )
}
